import { Link } from 'react-router-dom'
import { SITE_NAME } from '../../lib/siteMeta'

export interface PublicSiteFooterProps {
  className?: string
}

export function PublicSiteFooter ({ className = '' }: PublicSiteFooterProps) {
  const year = new Date().getFullYear()

  return (
    <footer className={`mt-auto w-full border-t border-border/80 bg-muted/30 ${className}`.trim()}>
      <div className="mx-auto flex max-w-6xl flex-col gap-4 px-4 py-8 sm:flex-row sm:items-center sm:justify-between sm:px-6">
        <p className="text-sm text-muted-foreground">
          © {year} {SITE_NAME}. Online salon-boekingsplatform.
        </p>
        <nav
          className="flex flex-wrap gap-x-5 gap-y-2 text-sm text-muted-foreground"
          aria-label="Juridisch en informatie"
        >
          <Link to="/over" className="hover:text-foreground">
            Over Guapaa
          </Link>
          <Link to="/privacy" className="hover:text-foreground">
            Privacy
          </Link>
          <Link to="/voorwaarden" className="hover:text-foreground">
            Voorwaarden
          </Link>
        </nav>
      </div>
    </footer>
  )
}
